import { render, staticRenderFns } from "./UpdateHubSpec.vue?vue&type=template&id=05bc4245"
import script from "./UpdateHubSpec.vue?vue&type=script&lang=js"
export * from "./UpdateHubSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports